import axios from '../../util/axios';
import {
    runTableScrollAnim
} from '../../util/Animation';

import {
    startAnim,
} from '../../util/util';
import ProjectLayer from '../../layer/ProjectLayer';

/**
 * 园区建设
 */
export default class ParkConstruction {
    constructor(main) {
        this.main = main;
        this.g2d = main.g2d;
        this.dm = main.g2d.dm();
        this.count = 0;
        this.htAnims = {};
        this.intervalAnims = {};
    }

    /**
     * 初始化 2D 面板上的数据
     */
    init() {
        const dm = this.dm;
        // 左侧
        const regionConstructionDetail = this.regionConstructionDetail = dm.getDataByTag('regionConstructionDetail');
        const parkConstructionProgress = this.parkConstructionProgress = dm.getDataByTag('parkConstructionProgress');

        // 右侧
        const projectQuantityStatistic = this.projectQuantityStatistic = dm.getDataByTag('projectQuantityStatistic');
        const pipesBuildingProgress = this.pipesBuildingProgress = dm.getDataByTag('pipesBuildingProgress');
        const resourceUse = this.resourceUse = dm.getDataByTag('resourceUse');
        this.initProgressValue = [];

        // 施工项目时间切换事件
        const constructionProjectTime = dm.getDataByTag('constructionProjectTime');
        constructionProjectTime.getChildAt(0).s('onUp', () => {
            this.changeConstructionProjectChart();
        });
        constructionProjectTime.getChildAt(1).s('onUp', () => {
            this.changeConstructionProjectChart('day');
        });

        axios.get('getParkConstructionInfo').then(res => {
            this.subjectDatas = res;
            const constructionDetailInfoData = Object.values(res.constructionDetailInfo);
            
            // 园区建设进度
            parkConstructionProgress.eachChild(node=> {
                node.a('progress', 0);
            });

            // 建设详情
            regionConstructionDetail.eachChild((node,j) => {
                node.a('ht.dataSource', constructionDetailInfoData[j]);
                node.a('ht.translateY', 0);
            });

            // 项目概况
            const projectCount = res.projectCount;
            projectQuantityStatistic.eachChild(node => {
                const name = node.a('name');
                if(projectCount[name] || projectCount[name] === 0) {
                    node.a('value', projectCount[name]);
                }
            });

            // 管道建设
            pipesBuildingProgress.eachChild((node,i) => {
                const value = res.pipeProgresValue[i];
                node.a('percentage', value);
                this.initProgressValue[i] = value;
            });

            // 资源使用
            const resourceUseData = res.resourceUse;
            resourceUse.eachChild(node => {
                const name = node.a('name');
                if(resourceUseData[name] || resourceUseData[name] === 0) {
                    node.a('value', resourceUseData[name]);
                }
            });

            // 施工项目
            this.changeConstructionProjectChart();
    
            this.start2DAnim();
        });
        
    }

    /**
     * 启动 2D 上的动画
     */
    start2DAnim() {
        // 先清除动画，避免重复调用 start2DAnim 但未调用过 stop2DAnim 的误操作。
        this.stop2DAnim();
        const pipesBuildingProgress = this.pipesBuildingProgress;
        const initProgressValue = this.initProgressValue;
        const params = {
            delay: 2000,
            duration: 3000,
            easing: t => t,
            action: v => {
                pipesBuildingProgress.eachChild((node,i) => {
                    node.a('percentage', initProgressValue[i] * v);
                });
            },
            finishFunc: () => {
                this.htAnims.pipeProgressAnim = startAnim(params);
            }
        };
        this.htAnims.pipeProgressAnim = startAnim(params);

        // 园区建设进度动画
        const parkConstructionProgressValues = Object.values(this.subjectDatas.parkConstructionProgress);
        this.htAnims.constructionProgressAnim = startAnim({
            duration: 3000,
            easing: t => (0.3 + t),
            action: v => {
                if(v <= 1) {
                    this.parkConstructionProgress.eachChild((node,i) => {
                        node.a('progress', parkConstructionProgressValues[i] * v);
                    });
                }
            }
        });

        // 区域建设详情
        const regionConstructionDetail = this.regionConstructionDetail;
        regionConstructionDetail.eachChild((node,i) => {
            this.htAnims[`tableRoll${i}`] = runTableScrollAnim(node, {
                loop: true,
                dir: -1,
                delay: (i + 1) * 1000,
                duration: 2000
            });
        });

        // 地图上的动画

        // 建设进度动画
        const projectLayerAnimParams = {
            delay: 5000,
            duration: 3000,
            easing: t => t,
            action: v => {
                if(this.projectLayer) {
                    this.projectLayer.nodes.forEach(node => {
                        const properties = node.a('properties');
                        node.a('progress', v * properties.progress / 100);
                    });
                }
            },
            finishFunc: () => {
                this.htAnims.projectLayerAnim = startAnim(projectLayerAnimParams);
            }
        };

        this.htAnims.projectLayerAnim = startAnim(projectLayerAnimParams);
    }

    /**
     * 停止移除 2D 上的动画
     */
    stop2DAnim() {
        Object.values(this.htAnims).forEach(anim => {
            anim.pause();
        });
        this.htAnims = {};
    }

    /**
     * 切换施工项目的图表数据
     * @param {*} time 
     */
    changeConstructionProjectChart(time = 'month') {
        const dm = this.dm;
        const parkConstructionProject = dm.getDataByTag('parkConstructionProject');
        const constructionProjectTime = dm.getDataByTag('constructionProjectTime');
        if(this.subjectDatas) {
            const constructionProjectData = this.subjectDatas.constructionProject[time];
            parkConstructionProject.getChildAt(1).a('time', constructionProjectData.time);
            constructionProjectTime.getChildAt(0).s('state', time === 'month' ? '选中' : '默认');
            constructionProjectTime.getChildAt(1).s('state', time === 'month' ? '默认' : '选中');

            parkConstructionProject.getChildAt(3).a({
                seriesData1: constructionProjectData.yData,
                xAxisData: constructionProjectData.xData,
            });
        }
    }

    /**
     * 开启 BIM 建筑图层
     */
    openBIMLayer() {
        const {
            main,
            dm
        } = this;
        const pageMap = main.pageMap;
        const map = pageMap.map;
        const bimLayer = pageMap.bimLayer;

        // 关闭项目图层和施工图层
        this.closeProjectLayer();
        
        map.flyTo({
            heading: 69.99298512065776,
            height: 145.05911100032444,
            pitch: -10.086233637774365,
            position: [118.03845165356215, 24.614793738069825],
            roll: 0.0024225418460499526,
            animation: {
                duration: 2000
            }
        }, () => {
            pageMap.setBIMSceneVisible(true);
            bimLayer.startBuildAnimation();
        });
    }

    /**
     * 关闭 BIM 图层
     */
    closeBIMLayer() {
        const {
            main,
            dm
        } = this;

        const pageMap = main.pageMap;
        const bimLayer = pageMap.bimLayer;

        const bimBuilding = dm.getDataByTag('bimBuilding');
        bimBuilding.a('active', false);
        bimBuilding.s('state', '默认');

        pageMap.setHomeView();
        pageMap.setBIMSceneVisible(false);
        bimLayer.stopBuildingAnimation();
    }
    
    /**
     * 开启项目分布
     * @param {*} type 
     */
     openProjectLayer() {
        const map = this.main.pageMap.map;
        let projectLayer = this.projectLayer;

        // 关闭 BIM 图层和施工图层
        this.closeBIMLayer();

        if(projectLayer) {
            projectLayer.showLayer();
        }
        else {
            axios.get('getProjectData').then(res => {
                res.reverse();
                projectLayer = new ProjectLayer(map, res);
                projectLayer.showLayer();
                this.projectLayer = projectLayer;
            });
        }
    }
    /**
     * 关闭项目分布
     */
    closeProjectLayer() {
        const dm = this.dm;
        const projectLayer = this.projectLayer;
        if(projectLayer) {
            projectLayer.hideLayer();
        }
        const projectDistribution = dm.getDataByTag('projectDistribution');
        projectDistribution.a('active', false);
        projectDistribution.s('state', '默认');
    }
    
    /**
     * 显示工程信息数据点
     * @param {*} data 
     */
    showProjectInfo(data) {
        const projectLayer = this.projectLayer;
        if(projectLayer) {
            projectLayer.showPointInfo(data);
        }
    }

    /**
     * 清除关闭所有动画及数据更新
     */
    clear() {
        this.closeProjectLayer();
        this.closeBIMLayer();

        this.stop2DAnim();
    }
}